import { Component, Input } from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { TimeBudgetView } from '../../models/timebudgetView';
@Component({
    selector: 'app-statistik-kunde-plantid-modal-ui',
    templateUrl: './statistik-modal-plantid.component.html',
    standalone: false
})
export class StatistikKunderPlantidModalComponent {
    @Input() timebudgets: TimeBudgetView[];
    @Input() medID: number;
    @Input() month: any;
    @Input() year: number;

    constructor(
        private activeModal: NgbActiveModal,
    ) {}

    onDismiss() {
        this.activeModal.dismiss();
    }
}
